import React from "react";
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import Basemap from './Basemaps';
import './Map.css';
import GeojsonLayer from "./GeojsonLayerFunc";




// указываем путь к файлам marker
L.Icon.Default.imagePath = "https://unpkg.com/leaflet@1.5.0/dist/images/";

class MapComponent extends React.Component {
  state = {
    lat: 49.5033,
    lng: 24.0156,
    zoom: 3,
    basemap: 'osm',
    geojsonvisible: true,
  };

  onBMChange = (bm) => {
    this.setState({
      basemap: bm
    });
  }

  onGeojsonToggle = (e) => {
    
    this.setState({
      geojsonvisible: e.currentTarget.checked
    });
  }

  render() {
    var center = [this.state.lat, this.state.lng];

    const basemapsDict = {
      osm: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      hot: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
    }

    return (
      <>
      {/* <h3>Інтерактивна карта пунктів відбору проб води</h3> */}
      <MapContainer zoom={this.state.zoom} center={center}>
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url={basemapsDict[this.state.basemap]}
        />
        {/* <Basemap basemap={this.state.basemap} onChange={this.onBMChange} /> */}

    
      
        {/* <div className="geojson-toggle">
          <label htmlFor="layertoggle">Toggle Geojson </label>
          <input type="checkbox"
            name="layertoggle" id="layertoggle"
            value={this.state.geojsonvisible} onChange={this.onGeojsonToggle} />
        </div>  */}
        
        {this.state.geojsonvisible && 
          <GeojsonLayer url="data.json" cluster={true}/>
        }

        {/* <Marker position={center}>
          <Popup><div>Вибрана карта {this.state.basemap}</div></Popup>
        </Marker> */}
      </MapContainer>
      </>
    );
  }
};

export default MapComponent;